export const getWithoutError = async (url) => {
    const request = new Request(url, {
        method: 'GET',
        headers: {
            Authorization: sessionStorage.token,
            'Accept-Language': sessionStorage.getItem('iflares_language')
                ? sessionStorage.getItem('iflares_language')
                : 'es',
            Accept: 'application/json',
            'Content-Type': 'application/json',
        },
    });
    return fetch(request)
        .then((response) => {
            return response.json();
        })
        .then((info) => {
            if (info.result !== 'success') {
                return undefined;
            }
            return info.data;
        })
        .catch((err) => {
            throw err;
        });
};

export const get = async (url) => {
    const request = new Request(url, {
        method: 'GET',
        headers: {
            Authorization: sessionStorage.token,
            'Accept-Language': sessionStorage.getItem('iflares_language')
                ? sessionStorage.getItem('iflares_language')
                : 'es',
            Accept: 'application/json',
            'Content-Type': 'application/json',
        },
    });
    return fetch(request)
        .then((response) => {
            return response.json();
        })
        .then((info) => {
            if (info.result !== 'success') {
                console.error(info.messages);
                const error = { type: info.result, message: info.messages.join('<br/>') };
                throw error;
            }
            return info.data;
        })
        .catch((err) => {
            throw err;
        });
};

export const put = async (url, body) => {
    const request = new Request(url, {
        method: 'PUT',
        headers: {
            Authorization: sessionStorage.token,
            'Accept-Language': sessionStorage.getItem('iflares_language')
                ? sessionStorage.getItem('iflares_language')
                : 'es',
            Accept: 'application/json',
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(body),
    });
    return fetch(request)
        .then((response) => {
            return response.json();
        })
        .then((info) => {
            if (info.result !== 'success') {
                console.error(info.messages);
                const error = { type: info.result, message: info.messages.join('<br/>') };
                throw error;
            }
            return info.data;
        })
        .catch((err) => {
            throw err;
        });
};

export const post = async (url, body) => {
    const request = new Request(url, {
        method: 'POST',
        headers: {
            Authorization: sessionStorage.token,
            'Accept-Language': sessionStorage.getItem('iflares_language')
                ? sessionStorage.getItem('iflares_language')
                : 'es',
            Accept: 'application/json',
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(body),
    });
    return fetch(request)
        .then((response) => {
            return response.json();
        })
        .then((info) => {
            if (info.result !== 'success') {
                console.error(info.messages);
                const error = { type: info.result, message: info.messages.join('<br/>') };
                throw error;
            }
            return info.data;
        })
        .catch((err) => {
            throw err;
        });
};

export const del = async (url) => {
    const request = new Request(url, {
        method: 'DELETE',
        headers: {
            Authorization: sessionStorage.token,
            'Accept-Language': sessionStorage.getItem('iflares_language')
                ? sessionStorage.getItem('iflares_language')
                : 'es',
            Accept: 'application/json',
            'Content-Type': 'application/json',
        },
    });
    return fetch(request)
        .then((response) => {
            return response.json();
        })
        .then((info) => {
            if (info.result !== 'success') {
                console.error(info.messages);
                const error = { type: info.result, message: info.messages.join('<br/>') };
                throw error;
            }
            return info.data;
        })
        .catch((err) => {
            throw err;
        });
};



// WEBPACK FOOTER //
// ./src/api/_basic.js